import {
  swalNotification,
} from "../components/alret/notificztion";

export const formObjectIsEmpty = (value) => {
  if (
    value &&
    Object.keys(value).length === 0 &&
    value.constructor === Object
  ) {
    return true;
  } else if (
    value &&
    Object.keys(value).length !== 0 &&
    value.constructor === Object
  ) {
    let isErr = false;
    Object.values(value).map((val) => {
      if ((val === null || val === undefined || val === "", val?.length < 1)) {
        isErr = true;
      }
      return "";
    });
    return isErr;
  } else {
    return false;
  }
};

export const validationErrors = (error) => {
  if (error.response.data.code === 400) {
    let errors = "";
    if (error.response.data.data !== null) {
      const objKeys = Object.keys(error.response.data.data);
      if (Object.values(error.response.data.data).length > 1) {
        Object.values(error.response.data.data).map((k, i) => {
          // errors += objKeys[i] + " -- " + k + " on row " + (i + 1) + "\n";
          errors +=
            objKeys[i].substring(objKeys[i].indexOf(".") + 1) +
            " -- " +
            k +
            " on row " +
            (i + 1) +
            "\n";
          return "";
        });
      } else {
        Object.values(error.response.data.data).map((k, i) => {
          errors = objKeys[i].substring(objKeys[i].indexOf(".") + 1) + " -- " + k;
          return "";
        });
      }
      swalNotification(error.response.data.message, errors, "error");
    } else {
      swalNotification(
        error.response.data.message,
        error.response.data.message,
        "error"
      );
    }
    return null;
  }
  if (error.response.data.code === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("user_id");
    localStorage.removeItem("persist:Rocky_dashboard");
    window.location = "/";
  }
  if (error.response.data.code === 406) {
    // openNotification(
    //   error.response.statusText,
    //   error.response.data.message,
    //   "error"
    // );
    swalNotification(
      error.response.statusText,
      error.response.data.message,
      "error"
    );
    return null;
  }
  if (error.response.data.code === 409) {
    // openNotification(
    //   error.response.statusText,
    //   error.response.data.message,
    //   "error"
    // );
    swalNotification(
      error.response.statusText,
      error.response.data.message,
      "error"
    );
    return null;
  }
  if (error.response.data.code === 500) {
    // openNotification(
    //   error.response.statusText,
    //   error.response.data.message,
    //   "error"
    // );
    swalNotification(
      error.response.statusText,
      error.response.data.message,
      "error"
    );
    return null;
  } else {
    // openNotification("There was an error!", error.message, "error");
    swalNotification("There was an error!", error.message, "error");
    console.error("There was an error!", error.message);
  }
};

export const orderStatuses = (slug, type, title) => {
  // console.log("slug, type, title: ",slug, type, title)
  let temp = "";
    if(slug === "arrived" && type === "pickup") temp = "Pickup Reached";
    else if(slug === "assigned" && type === "pickup") temp = "Accepted";
    else if(slug === "started" && type === "pickup") temp = "Pickup Started";
    else if(slug === "completed" && type === "pickup") temp = "Pickup Successful";
    else if(slug === "started" && type === "delivery") temp = "Dropoff Started";
    else if(slug === "arrived" && type === "delivery") temp = "Dropoff Reached";
    else if(slug === "completed" && type === "delivery") temp = "Dropoff Successful";
    else if(slug === "cancel" && type === "delivery") temp = "Canceled";
    else if(slug === "cancel" && type === "pickup") temp = "";
    else if(slug === "un-assigned" && type === "delivery") temp = "";
    else if(slug === "assigned" && type === "delivery") temp = "";
    else temp = title;
    return temp;
}

// New overview page
export const overviewStatuses = (slug, type, title) => {
  let temp = "";
    if(slug === "accepted" && type === "pickup") temp = "Pickup Accepted";
    else if(slug === "started" && type === "pickup") temp = "Pickup Accepted";
    else if(slug === "arrived" && type === "pickup") temp = "Pickup Reached";
    else if(slug === "completed" && type === "pickup") temp = "Pickup Successful";
    else if(slug === "assigned" && type === "delivery") temp = "Dropoff Assigned";
    else if(slug === "started" && type === "delivery") temp = "Dropoff Started";
    else if(slug === "arrived" && type === "delivery") temp = "Dropoff Reached";
    else if(slug === "completed" && type === "delivery") temp = "Dropoff Successful";
    else if(slug === "cancel") temp = "Canceled";
    else temp = title;
    return temp;
}

export const taskButtonStatuses = (values, called_from="") => {  
  const data = values && values.find((item)=>{
    if(item.job_type == "delivery") {
      return true;
    }
  });
  const result = data && data.status.find((d)=>d.current == true && ((d.slug == "completed" && called_from == "called_from_complete") || (d.slug == "cancel"  && called_from == "called_from_cancel") || ((d.slug == "completed" || d.slug == "cancel") && called_from == "") ));
  return result || result != undefined?true:false;
}


export const optionLabel = (data) => {
  if(data === undefined) {
    return;
  } else {
    data = data.replace('_', ' ');
    return data.replace(/(^|\s)\S/g, function(t) { return t.toUpperCase() }) || "";
  }
}

const userAuthEmail = [
  "hammad@kravemart.com",
  "umair.arshad@kravemart.com",
  "hassan.zafar@kravemart.com",
  "fayyaz.rehman@kravemart.com",
  "jahanzaib.ahmed@kravemart.com",
  "muqeet.khan@kravemart.com",
  "hasan.bilal@kravemart.com",
  "waqas.baig@kravemart.com",
  "aaqash.ali@kravemart.com",
  "zain.hasan@kravemart.com",
  "zain.hassan@kravemart.com",
  "ibtesam.khan@kravemart.com",
  "sami.khan@kravemart.com",
  "zohaib@kravemart.com",
  "wassay.razaque@kravemart.com",
  "shariq.shahab@kravemart.com",
  "hammad.khan@kravemart.com",
];
export const userEmailAllow = (value) => {
  return JSON.stringify(userAuthEmail).includes(value);
}

// rs dashboard access users
const userAuthEmailForRsDashboardOnly = [
  "moeez.shaikh@kravemart.com",
  "muhammad.naveed@kravemart.com",
  "shahrukh.ahmed@kravemart.com",
  "turab.naqvi@kravemart.com",
  "mohsin.ali@kravemart.com",
  "muneeb.ahmed@kravemart.com",
  "muhammad.ali@kravemart.com",
  "junaid.khan@kravemart.com",
  "asad.ahmed@kravemart.com",
  "saad.yousuf@kravemart.com",
  "usama.ansari@kravemart.com",
  "sameer.gulzar@kravemart.com",
  "nameer.shah@kravemart.com",
  "shayan.hussain@kravemart.com",
  "muhammad.adil@kravemart.com",
  "kamran.shahid@kravemart.com",
  "rishna.joseph@kravemart.com",
  "soban.ali@kravemart.com",
  "mubashir.khatri@kravemart.com",
  "faaran.saleem@kravemart.com",
  "salman.qadeer@kravemart.com",
  "shayan.shamim@kravemart.com",
  "haziq@kravemart.com",
  "wassay.razaque@kravemart.com",
  "mustafa.hamza@kravemart.com",
  "faizan.ali@kravemart.com",
  "umair.sohail@kravemart.com",
  "faizan.mubeen@kravemart.com",
  "shaheryar.ahmed@kravemart.com",
  "faheem.naqvi@kravemart.com",
  "muhammad.adnan@kravemart.com",
  "fahd.malik@kravemart.com",
  "faizan.masood@kravemart.com",
  "ahsan.raza@kravemart.com",
  "ali.siddiqui@kravemart.com",
  "kaleem.ahsan@kravemart.com",
  "sukaina.hassan@kravemart.com",
  "shehroze.shahid@kravemart.com",
  "taqi.naqvi@kravemart.com",
  "shariq.shahab@kravemart.com",
];

export const userEmailAllowForRsDashboard = (value) => {
  return JSON.stringify([...userAuthEmail,...userAuthEmailForRsDashboardOnly]).includes(value);
}

const riderTab = [
  "umair.arshad@kravemart.com",
  "hassan.zafar@kravemart.com",
  "hammad@kravemart.com",
  "zain.hasan@kravemart.com",
  "zain.hassan@kravemart.com",
  "ibtesam.khan@kravemart.com",
  "sami.khan@kravemart.com",
  "zohaib@kravemart.com",
  "waqas.baig@kravemart.com",
  "hurerah.khan@kravemart.com",
  "moeez.shaikh@kravemart.com",
  "turab.naqvi@kravemart.com",
  "fayyaz.rehman@kravemart.com",
  "shariq.shahab@kravemart.com",
  "hammad.khan@kravemart.com",
];
export const userEmailAllowForRiderTab = (value) => {
  return JSON.stringify([...riderTab]).includes(value);
}

const userReassignAuthEmail = [
  "moeez.shaikh@kravemart.com",
  "shahrukh.ahmed@kravemart.com",
  "muhammad.naveed@kravemart.com",
  "muneeb.ahmed@kravemart.com",
  "wassay.razaque@kravemart.com",
  "fayyaz.rehman@kravemart.com",
  "umair.arshad@kravemart.com",
  "hassan.zafar@kravemart.com",
  "hammad@kravemart.com",
  "faizan.masood@kravemart.com", 
  "ibtesam.khan@kravemart.com",
  "sami.khan@kravemart.com",
  "shariq.shahab@kravemart.com",
  "hammad.khan@kravemart.com",
];
export const userReassignEmailAllow = (value) => {
  return JSON.stringify(userReassignAuthEmail).includes(value);
}

export const userhasPermissionHelper = (permissions_array, permission_name) => {
  let has_permission = false;
  if(permissions_array && permissions_array.find(e => e.name === permission_name)){
    has_permission = true;
  }else{
    has_permission = false;
  }
  return has_permission;
}

export const breakPlainOptionsreason = [
  {
    label: "Accident",
    value: "Accident",
  },
  {
    label: "High Order Cancellation",
    value: "High Order Cancellation",
  },
  {
    label: "Looking for COD change",
    value: "Looking for COD change",
  },
  {
    label: "Pause",
    value: "Pause",
  },
  {
    label: "Order Marked Delivered",
    value: "Order Marked Delivered",
  },
  {
    label: "Vehicle/Equipment/Phone Issue",
    value: "Vehicle/Equipment/Phone Issue",
  },
  {
    label: "Rider marked order completed",
    value: "Rider marked order completed",
  },
  {
    label: "Equipment Issue",
    value: "Equipment Issue",
  },
  {
    label: "Fuel Issue",
    value: "Fuel Issue",
  },
  {
    label: "Food Break",
    value: "Food Break",
  },
  {
    label: "Prayer Break",
    value: "Prayer Break",
  },
  {
    label: "Personal Emergency",
    value: "Personal Emergency",
  },
  {
    label: "Others",
    value: "Others",
  },
  {
    label: "Wallet Compliance Hold",
    value: "Wallet Compliance Hold",
  },
  {
    label: "Out of Radius",
    value: "Out of Radius",
  },
  {
    label: "Rider Logout",
    value: "Rider Logout",
  },
];

export const breakPlainOptionsTime = [
  {
    label: "5 min",
    value: "5",
  },
  {
    label: "10 min",
    value: "10",
  },
  {
    label: "15 min",
    value: "15",
  },
  {
    label: "20 min",
    value: "20",
  },
  {
    label: "25 min",
    value: "25",
  },
  {
    label: "30 min",
    value: "30",
  },
  {
    label: "Until Shift Ends",
    value: "0",
  },
  // {
  //   label: "Customize",
  //   value: "customize",
  // },
];

export const typeOption = [
  {value: 'order_not_packed', label: 'Order not packed'},
  {value: 'order_not_accepted', label: 'Order not accepted'},
  {value: 'order_not_picked_up', label: 'Order not picked up'},
  {value: 'order_is_partial', label: 'Order is partial'},
  {value: 'new_customer_order', label: 'New Customer Order'},
  {value: 'new_customer_order_cancel', label: 'New Customer Order Cancel'},
  {value: 'full_partial_order', label: 'Full Partial Order'},
]


export const dataKey = (data) => {
  if(data.length !== 0){
    const dataKey = [];
    data.map((item, i)=>{return dataKey.push({key: i,...item})})
    return dataKey
  } else {
    return data
  }
}

export const DummyPermissionHelperTriggers = (value) => {
  let has_permission = false;
  has_permission = JSON.stringify([...DevUsers, ...ProductUsers]).includes(value);
  return has_permission
}

export const DummyPermissionHelperWork = (value) => {
  let has_permission = false;
  has_permission = JSON.stringify([...DevUsers, ...ProductUsers]).includes(value);
  return has_permission
}

const UnRegisterRiderUsers = [
  "fayyaz.rehman@kravemart.com",
  "moeez.shaikh@kravemart.com",
  "usama.ansari@kravemart.com",
  "muhammad.adnan@kravemart.com",
  "hammad.qasim@kravemart.com",
];

export const DummyPermissionHelperUnRegisterRider = (value) => {
  let has_permission = false;
  has_permission = JSON.stringify([...DevUsers, ...ProductUsers, ...UnRegisterRiderUsers]).includes(value);
  return has_permission
}

export const DummyPermissionHelper = (value) => {
  let has_permission = false;
  has_permission = JSON.stringify([...riderTab]).includes(value);
  return has_permission
}

const DevUsers = [
  "ibtesam.khan@kravemart.com",
  "hammad.khan@kravemart.com",
  "zohaib@kravemart.com",
  "waqas.baig@kravemart.com",
  "hurerah.khan@kravemart.com",
  "shariq.shahab@kravemart.com",
];

const ProductUsers = [
  "hammad@kravemart.com",
  "umair.arshad@kravemart.com",
  "hassan.zafar@kravemart.com",
];
const ReUploadProfileImageUsers = [
  "moeez.shaikh@kravemart.com",
  "turab.naqvi@kravemart.com",
  "muqeet.khan@kravemart.com", 
  "hammad.qasim@kravemart.com",
  "fayyaz.rehman@kravemart.com",
  "saad.yousuf@kravemart.com",
];
  
export const DevProductPermissionHelper = (value) => {
  let has_permission = false;
  has_permission = JSON.stringify([...DevUsers, ...ProductUsers, ...ReUploadProfileImageUsers]).includes(value);
  return has_permission
}

const cancelReasonUsers = [
  ...DevUsers,
  "fayyaz.rehman@kravemart.com",
  "hammad@kravemart.com",
  "umair.arshad@kravemart.com",
  "hassan.zafar@kravemart.com",
  "shaheryar.ahmed@kravemart.com",
];
export const DummyPermissionCancellationsreasonsHelper = (value) => {
  let has_permission = false;
  has_permission = JSON.stringify([...cancelReasonUsers]).includes(value);
  return has_permission
}

export const DummyPermissionReturnPickupHelper = (value) => {
  let has_permission = false;
  has_permission = JSON.stringify([...riderTab, "shaheryar.ahmed@kravemart.com"]).includes(value);
  return has_permission
}

const devsManagement = [
  "umair.arshad@kravemart.com",
  "hassan.zafar@kravemart.com",
  "hammad@kravemart.com",
  "zain.hasan@kravemart.com",
  "zain.hassan@kravemart.com",
  "ibtesam.khan@kravemart.com",
  "sami.khan@kravemart.com",
  "zohaib@kravemart.com",
  "waqas.baig@kravemart.com",
  "hurerah.khan@kravemart.com",
  "shariq.shahab@kravemart.com",
  "anas.mirza@kravemart.com",
  "nameer.shah@kravemart.com",
  "ahmed.razzaque@kravemart.com",
  "hammad.khan@kravemart.com",
];

const IssuesMarkCompleteAccess = [
  "mudasar.ahmed@kravemart.com", 
  "waleed.sheikh@kravemart.com", 
  "iqra.zarad@kravemart.com",
];

export const DevDummyPermissionHelper = (value) => {
  let has_permission = false;
  has_permission = JSON.stringify([...devsManagement, ...IssuesMarkCompleteAccess]).includes(value);
  return has_permission
}

const devsManagementS = [
  "ibtesam.khan@kravemart.com",
  "zohaib@kravemart.com",
  "hurerah.khan@kravemart.com",
  "shariq.shahab@kravemart.com",
  "hammad.khan@kravemart.com",
];

export const DevSDummyPermissionHelper = (value) => {
  let has_permission = false;
  has_permission = JSON.stringify([...devsManagementS]).includes(value);
  return has_permission
}

const SiteConfigUsers = [
  "muhammad.adnan@kravemart.com",
  "muqeet.khan@kravemart.com",
  "moeez.shaikh@kravemart.com",
  "faizan.mubeen@kravemart.com",
  "Sham.akbar@kravemart.com",
  "kamran.shahid@kravemart.com",
];
export const DevSDummyPermissionForSiteConfigHelper = (value) => {
  let has_permission = false;
  has_permission = JSON.stringify([...devsManagementS, ...SiteConfigUsers]).includes(value);
  return has_permission
}

const siteConfigDevDevelopers = [
  "ibtesam.khan@kravemart.com",
  "hammad.khan@kravemart.com",
];
export const SiteConfigDevPermissionHelper = (value) => {
  return JSON.stringify(siteConfigDevDevelopers).includes(value);
}

export const MartHealthDashboardStoreEmails = {
  // prepred
  // "northnazimabad.n@kravemart.com":"1176999",
  // "nazimabad1@kravemart.com":"1200102",
  // "allama.iqbalroad@kravemart.com":"1198759",
  // "mjohar@kravemart.com":"1171997",
  
  // prod
  "ibtesam.khan@kravemart.com":"1198759",
  "badar@kravemart.com":	"1190147",
  "gulshan.19@kravemart.com":	"1214988",
  "maskan@kravemart.com":	"1180153",
  "jami@kravemart.com":	"1190250",
  "mjohar@kravemart.com":	"1171997",
  "nazimabad1@kravemart.com":	"1200102",
  "north.karachi@kravemart.com":	"1241145",
  "northnazimabad.n@kravemart.com":	"1176999",
  "saddar.khi@kravemart.com":	"1223501",
  "allama.iqbalroad@kravemart.com":	"1198759",
  "model.colony@kravemart.com":	"1223499",
  "scheme.33@kravemart.com":	"1223485",
  "shahfaisal@kravemart.com":	"1215849",
  "bahria.town@kravemart.com":	"1227781",
  "cavalry.ground@kravemart.com":	"1228673",
  "iqbal.town@kravemart.com":	"1220772",
  "wapda.town@kravemart.com":	"1219881",
  "chaklala.3@kravemart.com":	"1228689",
  "aisha.manzil@kravemart.com":	"1242160",
  "lasbela@kravemart.com":	"1242161",
  "gulshan.13d@kravemart.com":	"1201717",
};
